import dayjs from "dayjs"
import 'dayjs/locale/de'

dayjs.locale('de')